import React, { useContext } from "react";
import { useEffectOnce } from "../../../utils/effects";
import { Box, Button, Grid, Typography, IconButton } from "@mui/material";
import DataTable from "../../dataTable/DataTable";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import { useDispatch, useSelector } from "react-redux";
import AuthContext from "../../../context/AuthContext";
import {
  getExchanges,
  modifyExchangeStatus,
} from "./Exchanges.thunk";
import { toggleLocalExchangeState } from "./Exchanges.slice";

const Exchanges = ({ setSubmenuMerchantTerminal, setSelectedOption, setNameSection }) => {
  const dispatch = useDispatch();
  const { token, acquirerData } = useContext(AuthContext);
  const { merchantId, exchanges, status, page, pageSize, totalRecords } = useSelector((s) => s.exchanges || {});

  useEffectOnce(() => {
    if (merchantId) {
      dispatch(
        getExchanges({
          token,
          acquirerID: acquirerData.acquirerId,
          merchantID: merchantId,
          acquirerName: acquirerData.acquirerName,
          isoID: acquirerData.isoID,
          page,
          pageSize,
        })
      );
    }
  });

  const columns = [
    {
      id: "icon",
      label: "",
      minWidth: 60,
      format: (value, row) => (
        <Box display="flex" alignItems="center" justifyContent="center">
          {value ? <img src={value} alt={row.name} style={{ width: 28 }} /> : <CurrencyExchangeIcon />}
        </Box>
      ),
    },
    { id: "code", label: "Code" },
    { id: "name", label: "Exchange" },
    { id: "category", label: "Category" },
    { id: "active", label: "Status", format: (v) => (v ? "Enabled" : "Disabled") },
    {
      id: "action",
      label: "Actions",
      actions: [
        (row) => (
          <IconButton
            title={row.active ? "Disable Exchange" : "Enable Exchange"}
            onClick={async () => {
              dispatch(toggleLocalExchangeState(row.id));
              try {
                await dispatch(
                  modifyExchangeStatus({
                    token,
                    merchantID: merchantId,
                    exchangeCode: row.code,
                    exchangeStatus: row.status,
                    exchangeCatalogId: row.catalogId,
                    category: row.category,
                    exchangeName: row.name,
                    exchangeRowKey: row.id,
                    acquirerId: acquirerData.acquirerId,
                    acquirerName: acquirerData.acquirerName,
                  })
                ).unwrap();
              } catch (err) {
                dispatch(toggleLocalExchangeState(row.id));
              }
            }}
            size="small"
            sx={{
              color: row.active ? 'primary.main' : 'inherit',
              fontWeight: 600,
              fontSize: '0.85rem',
              border: '1px solid',
              borderColor: row.active ? "primary.main" : "grey.400",
              borderRadius: 2,
              px: 1.5,
              py: 0.5,
              minWidth: 80,
              minHeight: 28,
              background: row.active ? 'rgba(81, 58, 151, 0.08)' : 'transparent',
              transition: 'all 0.2s',
              '&:hover': {
                background: row.active ? 'rgba(81, 58, 151, 0.14)' : 'action.hover',
              },
            }}
          >
            {row.active ? 'Enabled' : 'Disabled'}
          </IconButton>
        ),
      ],
    },
  ];

  const handleBack = () => {
    setSubmenuMerchantTerminal("merchant_area");
    setSelectedOption("merchant_area");
    setNameSection("Merchant & Terminal - Merchant & Terminal");
  };

  const handlePageChange = (event, newPage) => {
    dispatch(
      getExchanges({
        token,
        acquirerID: acquirerData.acquirerId,
        merchantID: merchantId,
        acquirerName: acquirerData.acquirerName,
        isoID: acquirerData.isoID,
        page: newPage + 1,
        pageSize,
      })
    );
  };

  const handleRowsPerPageChange = (event) => {
    const newPageSize = +event.target.value;
    dispatch(
      getExchanges({
        token,
        acquirerID: acquirerData.acquirerId,
        merchantID: merchantId,
        acquirerName: acquirerData.acquirerName,
        isoID: acquirerData.isoID,
        page: 1,
        pageSize: newPageSize,
      })
    );
  };

  return (
    <Box>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Grid item>
          <Typography variant="h6">Exchanges</Typography>
        </Grid>
        <Grid item>
          <Button size="small" variant="outlined" onClick={handleBack}>
            Back
          </Button>
        </Grid>
      </Grid>

      <DataTable
        columns={columns}
        rows={exchanges}
        loading={status === "loading"}
        page={page - 1}
        rowsPerPage={pageSize}
        count={totalRecords}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </Box>
  );
};

export default Exchanges;
